import React, { Component } from 'react';
import styled from 'styled-components';

import modules from './modules';
import TopSpacer from 'partials/TopSpacer';
import ErrorBoundary from 'partials/ErrorBoundary';

const Module = styled.div`
    ${props => props.name === 'courses' ? 'z-index: 10;' : ''}
`

const Error  = styled.div`
    color: red;
    text-align: center;
`

class Builder extends Component {
    _maybeRenderTopSpacer(modulesList = []) {
        const list = Array.isArray(modulesList) ? modulesList : [];
        const notUsingTopSpacer = ['courses', 'grade_calculator'];
        const first = list[0];

        if (list.length && first && first.acf_fc_layout && ~notUsingTopSpacer.indexOf(first.acf_fc_layout)) {
            return null;
        }

        return <TopSpacer />
    }

    render() {
        const { data, page } = this.props;
        const modulesList = Array.isArray(data) ? data : [];

        return (
            <div>
                {this._maybeRenderTopSpacer(modulesList)}

                <div className="modules">
                    {modulesList.map((module, i) => {
                        const layout = module && module.acf_fc_layout;
                        if (!layout) {
                            return <Error key={i}> Module data is missing layout key </Error>
                        }
                        if (!modules[layout]) {
                            return <Error key={i}> Module "{layout}" does not exist </Error>
                        }

                        return (
                            <Module key={i} className={'module-' + layout} name={layout}>
                                <ErrorBoundary for={'Module ' + layout}>
                                    {React.createElement(modules[layout], { data: module, page: page })}
                                </ErrorBoundary>
                            </Module>
                        )
                    })}
                </div>
            </div>
        );
    }
}

export default Builder;


// WEBPACK FOOTER //
// ./src/partials/Builder.js